module.exports = __webpack_public_path__ + "img/device.68110809.svg";